import { render, staticRenderFns } from "./SrTabs.vue?vue&type=template&id=22640d93"
import script from "./SrTabs.vue?vue&type=script&lang=js"
export * from "./SrTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports